import React from 'react';
import { MainView } from '@repo/ui/Views';
import SupportOverview from '../components/SupportOverview';

const Support = () => {
  return (
    <MainView title="Support">
      <SupportOverview />
    </MainView>
  );
};

export default Support;
